module.exports = __webpack_public_path__ + "img/logo_neonet.d9d78efb.svg";